import { useParams } from "react-router-dom";
import { TournamentFormatForm } from "./components/TournamentFormatForm";
import { tournamentFormatService } from "@/frontend/services";
import type { TournamentFormatResponseDTO } from "@/shared/dto";
import { useGetId } from "@/frontend/hooks/useGetId";
import { Spin } from "@/frontend/components/common";

export function UpdateTournamentFormatPage() {
  const { id } = useParams<{ id: string }>();
  const { data, loading } = useGetId<TournamentFormatResponseDTO>({
    fetchFn: tournamentFormatService.getById,
    redirectUrl: "/tournament-formats",
    errorMessage: "Error al cargar el formato de torneo",
    id,
  });

  if (loading) {
    return (
      <div className="bg-white rounded-lg p-6 shadow-sm w-full">
        <div className="flex justify-center items-center py-12">
          <Spin size="large" tip="Cargando..." />
        </div>
      </div>
    );
  }

  if (!data) return null;

  return (
    <div className="bg-white rounded-lg p-6 shadow-sm">
      <div className="mb-6">
        <h2 className="text-2xl font-bold">Editar Evento de Torneo</h2>
        <p className="text-gray-600 mt-1">
          Actualiza la información del evento seleccionado.
        </p>
      </div>
      <TournamentFormatForm
        tournamentFormatId={id}
        tournamentName={data.name}
        initialValues={{
          sport: data.sport,
          subCategoryId: (data.config as any)?.subCategoryId,
          matches: (data.config as any)?.matches,
        }}
      />
    </div>
  );
}
